import(/* webpackMode: "eager", webpackExports: ["SimulatePreloadedQuery"] */ "/app/node_modules/@apollo/client-react-streaming/dist/index.cc.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/public/images/og_image_default.png");
;
import(/* webpackMode: "eager" */ "/app/src/components/AppDownloadSection/assets/mobilePhonePreview.png");
;
import(/* webpackMode: "eager", webpackExports: ["AppRatingSection"] */ "/app/src/components/AppRatingSection/AppRatingSection.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/Clickables/Buttons/AppStoreButtons/AppStoreButtons.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FishingWaterCarousel"] */ "/app/src/components/FishingWaterCarousel/FishingWaterCarousel.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/QRCode/QRCode.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Rating"] */ "/app/src/components/Rating/Rating.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/helpers/errorHandling/client.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/views/PopularFishingWaters/assets/BGDesktop.png");
;
import(/* webpackMode: "eager" */ "/app/src/views/PopularFishingWaters/assets/BGMobile.png");
